import type { InjectionKey, Ref } from 'vue'

/** Toolbar Teleport target for HTML preview; use element ref (not a document selector). */
export const previewToolbarPortalKey: InjectionKey<Ref<HTMLElement | null>> =
  Symbol('previewToolbarPortal')
